<template>
    <div
        class="bg-white px-4 pt-2.5 pb-2 text-sm text-gray-500 shadow-md"
        v-if="breadcrumbs[0] && breadcrumbs[0].route != route().current()"
    >
        <template v-for="(breadcrumb, key) in breadcrumbs">
            <i class="fas fa-chevron-right fa-fw mx-1" aria-hidden="true" v-if=" key > 0 && key < breadcrumbs.length"></i>
            <Link
                :href="route(breadcrumb.route)"
                class="text-blue-light-500 hover:text-blue-dark-500 transition"
                v-if="breadcrumb.route && breadcrumb.route != route().current()"
            >
                {{ breadcrumb.text }}
            </Link>
            <span v-else>
                {{ breadcrumb.text }}
            </span>
        </template>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Link,
    },
    props: ["mainParentRoutes", "subRoutes"],
    computed: {
        breadcrumbs() {
            let crumbs = [];
            let routeParts = (route().current()) ? route().current().split('.') : []
            let parentRoute = routeParts[0]
            let childRoute = null

            let mainParent = this.mainParentRoutes.filter(obj => {
                return obj.route === routeParts[0]
            });

            crumbs.push(mainParent[0])

            for (let i = 1; i < routeParts.length; i++)
            {
                if (routeParts[i] != '.index')
                {
                    childRoute = parentRoute + '.' + routeParts[i]

                    //Get the child routes of a parent
                    let childRoutes = this.subRoutes[parentRoute]

                    if (childRoutes === undefined)
                    {
                        childRoutes = this.subRoutes[parentRoute + '.index']
                    }

                    if (childRoutes) {
                        let crumb = childRoutes.filter(obj => {

                            if (obj.url)
                            {
                                return window.location.href.includes(obj.url) && (obj.route === childRoute || obj.route === childRoute + '.index')
                            }
                            else
                            {
                                return obj.route === childRoute || obj.route === childRoute + '.index'
                            }
                        });

                        if (crumb[0])
                            crumbs.push(crumb[0])
                    }

                    parentRoute += '.' + routeParts[i]
                }
            }

            return crumbs;
        }
    },
}
</script>
